import patterns from 'utils/patterns';

/* eslint-disable */
export const priceSheetSegmentData: any = [
  {
    'field_map': 'priceSheetName',
    'item_name': 'price_sheet_name',
    'title': 'Price Sheet Name',
    'hint_detail': 'Price Sheet Name',
    'hint_panel' : 'Enter up to 30 characters to name price sheet referenced by price sheet number.',
    'example': 'Western Q1 2017 Price Sheet',
    'sequence': 1,
    'show_more': true,
    'lookup': null,
    'validation': {
      'PIES_6_5' : {
        required: true,
        minLength: 1,
        maxLength: 30,
        message: 'Price Sheet Name must be provided and is limited to 30 characters'
      }
    },
  },
  {
    'field_map': 'priceZone',
    'item_name': 'price_zone',
    'title': 'Price Zone',
    'hint_detail': 'Indicates the geographical zone in which this pricing is specific. This is not common and only one Price Zone is allowed per PIES file.',
    'hint_panel' : 'Enter geographical zone if pricing is specific to that area. This is not common and only one Price Zone is allowed per PIES file.',
    'example': 'Western',
    'sequence': 2,
    'show_more': true,
    'validation': {
      'PIES_6_5': {
        minLength: 1,
        maxLength: 10,
        pattern: /^\S*$/,
        message: 'Prize Zone is limited to 10 characters with no spaces'
      },
    },
    'lookup': null // might have to add a custom list of options. Docs does not have any options
  },
  {
    'field_map': 'priceSheetNumber',
    'item_name': 'price_sheet_number',
    'title': 'Price Sheet Number',
    'hint_detail': 'A unique identifier for the price sheet. After being defined a price sheet cannot be renumbered, it must be deleted.',
    'hint_panel' : 'Enter up to 15 characters to name price sheet referenced by price sheet number.',
    'example': 'Q12017Western',
    'sequence': 3,
    'show_more': true,
    'lookup': null,
    'validation': {
      'PIES_6_5' : {
        required: true,
        maxLength: 15,
        message: 'Price Sheet Number must be provided and is limited to 15 characters'
      }
    },
  },
  {
    'field_map': 'currencyCode',
    'item_name': 'currency_code',
    'title': 'Currency',
    'hint_detail': 'Currency',
    'hint_panel' : 'Currency for this price sheet. The default is US Dollar.',
    'example': '',
    'sequence': 4,
    'show_more': true,
    'lookup': [
      {
        'option': 'USD',
        'title': 'U.S. Dollar'
      },
      {
        'option': 'MXN',
        'title': 'Mexican Peso'
      },
      {
        'option': 'CAD',
        'title': 'Canadian Dollar'
      }
    ]
  },
  {
    'field_map': 'effectiveDate',
    'item_name': 'effective_date',
    'title': 'Effective date',
    'hint_detail': 'Date this price sheet goes into effect. ',
    'hint_panel' : 'Enter the date when pricing in this price sheet is in effect.',
    'example': '1/1/2017',
    'sequence': 5,
    'show_more': true,
    'lookup': null,
    'disable_since': {},
    'validation': {
      'PIES_6_5': {
        message: 'Effective date cannot be set ahead of Expiration date.',
      }
    }
  },
  {
    'field_map': 'expirationDate',
    'item_name': 'expiration_date',
    'title': 'Expiration date',
    'hint_detail': 'Expiration date',
    'hint_panel' : 'Enter the date when pricing in price sheet expires. Be sure to have another price sheet available in the system. Price sheet expiration date entry is not common.',
    'example': '12/31/2017',
    'sequence': 6,
    'show_more': true,
    'disable_since': {},
    'lookup': null
  },
  {
    'item_name': 'D35-ZZ1',
    'title': 'Select Price Type',
    'hint_detail': 'Select Price Type',
    'hint_panel' : 'Select Price Type',
    'example': '',
    'sequence': 7,
    'show_more': true,
    'lookup': null // Dynamic list of options
  },
  {
    'item_name': 'ZZZ-ZZ1',
    'title': 'Add Label',
    'hint_detail': 'Label for Custom Price Type',
    'hint_panel' : 'Label for Custom Price Type',
    'example': '',
    'sequence': 8,
    'show_more': true,
    'lookup': null
  },
  {
    'field_map': '_id',
    'item_name': '_id',
    'title': '',
    'hint_detail': '',
    'hint_panel' : '',
    'example': '',
    'sequence': 9,
    'show_more': true,
    'lookup': null
  },
  {
    'field_map': 'supersededPriceSheetNumber',
    'item_name': 'superseded_price_sheet_number',
    'title': '',
    'hint_detail': '',
    'hint_panel' : '',
    'example': '',
    'sequence': 10,
    'show_more': true,
    'lookup': null
  }
]
/* eslint-enable */
